/** Datum- och tidsformat för chattlistan och meddelandevyn. */

const time = new Intl.DateTimeFormat('sv-SE', { hour: '2-digit', minute: '2-digit' });
const weekdayShort = new Intl.DateTimeFormat('sv-SE', { weekday: 'short' });
const dayMonth = new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short' });
const dayMonthYear = new Intl.DateTimeFormat('sv-SE', { day: 'numeric', month: 'short', year: 'numeric' });
const fullDay = new Intl.DateTimeFormat('sv-SE', { weekday: 'long', day: 'numeric', month: 'long' });
const fullDayYear = new Intl.DateTimeFormat('sv-SE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** Hela dygn mellan datumet och idag. 0 = idag, 1 = igår. */
function daysAgo(date, now = new Date()) {
  return Math.round((startOfDay(now) - startOfDay(date)) / 86400000);
}

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Tidsstämpeln i konversationslistan — kort, som i en telefon.
 * Idag visas klockslag, igår "Igår", senaste veckan veckodag, äldre datum.
 */
export function formatListTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const days = daysAgo(date);
  if (days <= 0) return time.format(date);
  if (days === 1) return 'Igår';
  if (days < 7) return capitalize(weekdayShort.format(date).replace('.', ''));
  if (date.getFullYear() === new Date().getFullYear()) return dayMonth.format(date);
  return dayMonthYear.format(date);
}

/**
 * Dagen i ord: "Idag", "Igår", "Imorgon", veckodag inom en vecka, annars
 * datum. Används både som avdelare i chatten, där allt ligger bakåt, och
 * för träffar, som ligger framåt — därför hanteras båda riktningarna.
 */
export function formatDaySeparator(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const days = daysAgo(date);
  if (days === 0) return 'Idag';
  if (days === 1) return 'Igår';
  if (days === -1) return 'Imorgon';

  const formatter = date.getFullYear() === new Date().getFullYear() ? fullDay : fullDayYear;
  return capitalize(formatter.format(date));
}

/** Klockslag för ett enskilt meddelande. */
export function formatTime(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : time.format(date);
}

/**
 * Tidsspann for en traff: "Lördag 12 september 19:00–23:00", eller bara
 * starttiden nar sluttid saknas. Slutar traffen ett annat dygn skrivs
 * datumet ut aven for slutet.
 */
export function formatSpan(start, end) {
  if (!start) return '';
  const from = new Date(start);
  const label = `${formatDaySeparator(from)} ${time.format(from)}`;
  if (!end) return label;

  const to = new Date(end);
  if (Number.isNaN(to.getTime())) return label;

  return startOfDay(from).getTime() === startOfDay(to).getTime()
    ? `${label}–${time.format(to)}`
    : `${label} – ${formatDaySeparator(to)} ${time.format(to)}`;
}

/** Är de två tidsstämplarna från olika dygn? */
export function isDifferentDay(a, b) {
  if (!a || !b) return true;
  return startOfDay(new Date(a)).getTime() !== startOfDay(new Date(b)).getTime();
}
